import React, { useState, useEffect, useContext, useRef } from "react";
import styled from "styled-components";
import AppContext from "../../../context/store";
import axios from "axios";
import AdBlockChecker from "./AdBlockChecker";
import MetabaseSearch from "../../../theme/CustomMUI/MetabaseSearch";
import { iframeResize } from 'iframe-resizer';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

const TopBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 16px;
  background: white;
  border-bottom: 1px solid #e5e7eb;
`;

const Title = styled.h2`
  font-size: 18px;
  font-weight: 500;
  color: #111827;
  flex: 1;
`;

const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  width: 350px;
  position: relative;

  .MuiInputBase-root {
    width: 100%;
  }

  /* CustomerSearchScaffold'u dropdown genişliğiyle eşit olacak şekilde ayarla */
  > div {
    width: 100%;
  }
`;

const Content = styled.div`
  flex: 1;
  width: 100%;
  height: calc(100vh - 120px);
  margin-top: 20px;
`;

const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

const Spinner = styled.div`
  width: 48px;
  height: 48px;
  border: 2px solid #e5e7eb;
  border-bottom-color: #3b82f6;
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;

const ErrorMessage = styled.div`
  color: #ef4444;
  text-align: center;
  padding: 32px;
  background-color: #fef2f2;
  border: 1px solid #fee2e2;
  border-radius: 8px;
  margin: 16px;

  p {
    margin: 8px 0;
  }
`;

const StyledIframe = styled.iframe`
  width: 100%;
  height: 100%;
  border: none;
  min-height: 1450px;
`;

// Müşteri Dashboard bileşeni
const CustomerDashboard = () => {
  const context = useContext(AppContext);
  const [iframeUrl, setIframeUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [title, setTitle] = useState("Müşteriler Raporu");

  // URL önbelleği için ref kullanımı
  const urlCache = useRef({
    "dashboard4": null,
    "dashboard7": {}
  });

  // Seçilen müşteri değiştiğinde veya sayfa yüklendiğinde API isteği yap
  useEffect(() => {
    const fetchEmbedUrl = async () => {
      try {
        setLoading(true);

        // Uygulama adı ve test modu bilgisi al
        const appName = process.env.APP_NAME;
        const isTest = process.env.IS_TEST;

        // Seçilen müşteri varsa müşteri dashboard'unu, yoksa tüm müşteriler dashboard'unu göster
        const dashboardData = isTest
          ? selectedCustomer
            ? process.env.METABASE_IDS.TEST.CUSTOMER
            : process.env.METABASE_IDS.TEST.CUSTOMERS
          : selectedCustomer
            ? process.env.METABASE_IDS.LIVE.CUSTOMER[appName === "salon" ? "SR" : appName === "en" ? "ER" : "SM"]
            : process.env.METABASE_IDS.LIVE.CUSTOMERS[appName === "salon" ? "SR" : appName === "en" ? "ER" : "SM"];

        const dashboardId = dashboardData.id.toString();

        // Önbellek kontrolü
        let cachedUrl = null;

        if (!selectedCustomer) {
          // Tüm müşteriler raporu için önbellek kontrolü
          cachedUrl = urlCache.current[`dashboard${dashboardId}`];
        } else {
          // Müşteri dashboard'u için önbellek kontrolü
          if (!urlCache.current[`dashboard${dashboardId}`]) {
            urlCache.current[`dashboard${dashboardId}`] = {};
          }
          cachedUrl = urlCache.current[`dashboard${dashboardId}`][selectedCustomer.id];
        }

        // Eğer önbellekte URL varsa, API isteği atma
        if (cachedUrl) {
          console.log("Önbellekten URL kullanılıyor:", dashboardId);
          setIframeUrl(cachedUrl);

          if (selectedCustomer) {
            setTitle("Müşteri Dashboard");
          } else {
            setTitle("Müşteriler Raporu");
          }

          setLoading(false);
          return;
        }

        // Önbellekte yoksa API isteği at
        const endpoint = `company/analytics/embed/dashboard/${dashboardId}`;

        // Eğer müşteri seçildiyse customer_id parametresini ekle
        const params = new URLSearchParams();
        if (selectedCustomer) {
          params.append("customer_id", selectedCustomer.id);
          setTitle("Müşteri Dashboard");
        } else {
          setTitle("Müşteriler Raporu");
        }

        const response = await axios.get(`${context.api_endpoint}/${endpoint}${params.toString() ? '?' + params.toString() : ''}`);

        if (response.data && response.data.data) {
          const today = new Date()
          const formattedDate = today.toISOString().split('T')[0]

          let baseUrl = response.data.data

          const dateParams = new URLSearchParams();


          dateParams.append('ba%C5%9Flang%C4%B1%C3%A7_tarihi', `${formattedDate}T00:00:00`);
          dateParams.append('biti%C5%9F_tarihi', `${formattedDate}T23:59:00`);

          const separator = baseUrl.includes('?') ? '&' : '?';
          const embedUrl = `${baseUrl}${separator}${dateParams.toString()}`;

          setIframeUrl(embedUrl);
          // console.log("url son hali :", embedUrl)

          if (!selectedCustomer) {
            urlCache.current[`dashboard${dashboardId}`] = embedUrl;
          } else {
            urlCache.current[`dashboard${dashboardId}`][selectedCustomer.id] = embedUrl;
          }

          setTimeout(() => {
            iframeResize({
              log: false,
              checkOrigin: false,
              heightCalculationMethod: 'max'
            }, 'iframe');
          }, 1000);
        } else {
          setError("Rapor URL'si alınamadı");
        }
      } catch (err) {
        setError("Rapor yüklenirken bir hata oluştu");
        console.error("Rapor yükleme hatası:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchEmbedUrl();
  }, [selectedCustomer, context.api_endpoint]);

  // Önbelleği temizleme fonksiyonu - ihtiyaç halinde kullanılabilir
  const clearCache = () => {
    urlCache.current = {
      "dashboard4": null,
      "dashboard7": {}
    };
  };

  // Müşteri seçildiğinde tetiklenir
  const handleCustomerSelect = (customer) => {
    setSelectedCustomer(customer);
  };

  // Müşteri seçimi kaldırıldığında tetiklenir
  const handleCustomerRemove = () => {
    setSelectedCustomer(null);
  };

  return (
    <Container>
      <TopBar>
        <SearchContainer>
          <MetabaseSearch
            key={selectedCustomer ? 'selected' : 'empty'}
            label={context.t("newReports.customerSearch")}
            valueKey="id"
            labelKey="full_name"
            selectedHandler={handleCustomerSelect}
            onRemove={handleCustomerRemove}
            selected={selectedCustomer}
            style={{ width: "100%" }}
            searchEndpoint={`${context.api_endpoint}/company/customers`}
            responseDataField="records"
            searchParamName="key"
          />
        </SearchContainer>
      </TopBar>

      <Content>
        {loading ? (
          <LoadingContainer>
            <Spinner />
          </LoadingContainer>
        ) : error ? (
          <ErrorMessage>
            <p><strong>{context.t("newReports.error.title")}</strong></p>
            <p>{context.t("newReports.error.description")}</p>
            {context.t("newReports.error.steps").map((step, index) => (
              <p key={index}>{step}</p>
            ))}
          </ErrorMessage>
        ) : (
          <>
            <AdBlockChecker />
            <StyledIframe
              id="iframe"
              src={iframeUrl}
              allowTransparency
            />
          </>
        )}
      </Content>
    </Container>
  );
};

export default CustomerDashboard;
